<template>
    <div id="LockScreen">
        <div class="content">
            <div style="width: 100px;height: auto;margin: 0 auto;">
                <img src="images/w-imgs/lockScreen/lsicon.png" alt="" style="width: 100%; height: 100%;">
            </div>
            <div style="height: 32px;line-height: 32px;font-size: var(--portalFontSize14);font-weight: 700;">已锁定</div>
            <div style="height: 30px;line-height: 30px;font-size: var(--portalFontSize14);color: #999;">请输入登录密码解锁</div>
            <div style="height: 30px;line-height: 30px;font-size: var(--portalFontSize14);">当前登录用户：{{ curUser.personName }}</div>
            <div style="margin: 10px 0;">
                <el-input v-model="password" placeholder="请输入登录密码" show-password @keyup.enter.native="enterFn"></el-input>
            </div>
            <div style="padding-top: 20px;">
                <el-button id="entercheck" style="background: #418fff" icon="el-icon-right" type="primary" @click="enterFn">进 入</el-button>
            </div>
        </div>
    </div>
</template>

<script>
const encrypt = new window.JSEncrypt()
export default {
    components: {},
    props: {},
    data() {
        return {
            password: '',
            vo: {},
            curUser: {}
        }
    },
    computed: {
    },
    watch: {},
    created() {

    },
    beforeDestroy() {},
    mounted() {
        setTimeout(() => {
            this.curUser = window.$wapp.$store.getters.loginUser
            console.log('curUser', this.curUser)
        }, 1000)
    },
    methods: {
        enterFn() {
            // window.$wapp.isLocked = false
            // window.$wapp.refresh()

            if (this.password) {
                this.$http({
                    method: 'GET',
                    url: 'login/getRsaPublicKey'
                }).then((res) => {
                    if (res.code === 'success') {
                        encrypt.setPublicKey(res.body.rsaPublicKey)
                        // const paramsObj = $.extend(true, {}, this.loginForm)
                        const password = encrypt.encrypt(this.password)
                        this.$http({
                            method: 'post',
                            url: 'base/userpwd/checkoutPwd',
                            params: {
                                // password: encrypt.encrypt(this.password)
                                password: password
                            }
                        }).then(res => {
                            if (res.code === 'success') {
                                // console.log('===>res', res)
                                // window.$wapp.isLocked = false
                                // window.$wapp.refresh()
                                this.$bus.emit('refresh')
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                })
            } else {
                this.$message.warning('请输入登录密码')
            }
        }

    }
}
</script>

<style scoped lang="scss">
#LockScreen {
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2000;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('~public/images/w-imgs/lockScreen/lsbg.png') no-repeat;
        background-size: 100% 100%;
        opacity: 0.95; /* 调整背景图片的透明度 */
        z-index: -1; /* 确保背景图片在内容下方 */
    }

    .content {
        width: 300px;
        height: 500px;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        padding: 0 40px;
        background: #fff; /* 设置内容区域背景为白色或其他颜色 */
        z-index: 1; /* 确保内容在背景上方 */
    }
}
</style>
